import styled from 'styled-components';

const ResultsFooter = styled.div`
  margin-top: 30px;
`;

ResultsFooter.displayName = 'ResultsFooter';

export default ResultsFooter;
